import { Dispatch } from "redux";
import {JackpotAction, JackpotActionTypes} from "../../types/Jackpot/jackpotTypes";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

export const getJackpotData = (id: string): any => {
    return async (dispatch: Dispatch<JackpotAction>) => {
        try {
            dispatch({ type: JackpotActionTypes.FETCH_JACKPOT_DATA });
            const response = await axios({
                method: 'get',
                url: `/api/jackpot_cards/${id}`,
                withCredentials: false
            });
            dispatch({ type: JackpotActionTypes.FETCH_JACKPOT_DATA_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: JackpotActionTypes.FETCH_JACKPOT_DATA_ERROR, payload: errorPayload });
        }
    }
}
